var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 50,
    viewBox: "0 0 21 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 31C0.966667 31 0.652667 30.8696 0.391333 30.6087C0.130444 30.3473 0 30.0333 0 29.6667V20.3333C0 19.9667 0.130444 19.6527 0.391333 19.3913C0.652667 19.1304 0.966667 19 1.33333 19H5.33333V31H1.33333ZM6.66667 31V25H12V29.6667C12 30.0333 11.8696 30.3473 11.6087 30.6087C11.3473 30.8696 11.0333 31 10.6667 31H6.66667ZM6.66667 23.6667V19H10.6667C11.0333 19 11.3473 19.1304 11.6087 19.3913C11.8696 19.6527 12 19.9667 12 20.3333V23.6667H6.66667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardLogo);
export default __webpack_public_path__ + "static/media/DashboardLogo.fbd6f573a47e2fddb4274796c7eb222a.svg";
export { ForwardRef as ReactComponent };